import empresas from './modules/empresas'
import auth from './modules/auth'
import orcamentos from './modules/orcamentos'
import sincronizacoes from './modules/sincronizacoes'
import ccBloqueados from './modules/ccBloqueados'
import usuarios from './modules/usuarios'
import permissoes from './modules/permissoes'
import usuariosPermissao from './modules/usuariosPermissao'
import ccPais from './modules/ccPais'
import ccFilhos from './modules/ccFilhos'
import receitas from './modules/receitas'
import registros from './modules/registros'
import memoriasCalculos from './modules/memoriasCalculos'
import naturezasOrcamentarias from './modules/naturezasOrcamentarias'
import metas from './modules/metas'
import codigosOrcamentarios from './modules/codigosOrcamentarios'
import upload from './modules/upload'
import relatorios from './modules/relatorios'
import embeds from './modules/embeds'

export default {
  empresas,
  auth,
  orcamentos,
  sincronizacoes,
  ccBloqueados,
  usuarios,
  permissoes,
  usuariosPermissao,
  ccPais,
  ccFilhos,
  receitas,
  registros,
  memoriasCalculos,
  naturezasOrcamentarias,
  metas,
  codigosOrcamentarios,
  upload,
  relatorios,
  embeds,
}
